import { DraggableHandler, useAppSelector } from '@monorepo/shared';
import { selectDebugKey } from '@monorepo/shared/store/authSlice';
import { Nav, Sidebar, Sidenav } from 'rsuite';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { selectHasGroup } from '@monorepo/shared/store/groupSlice';

export const Sidemenu = () => {
  const navigate = useNavigate();
  const [width, setWidth] = useState<number>(160);
  const { pathname } = useLocation();
  const debugKey = useAppSelector(selectDebugKey);
  const hasGroup = useAppSelector(selectHasGroup);

  const draggableHandler = useMemo(
    () => (
      <DraggableHandler
        setWidth={setWidth}
        isRight={false}
        hoverStyle={{ backgroundColor: '#1551d4' }}
      />
    ),
    [setWidth]
  );

  interface IGetIcon {
    name: string;
    active?: boolean;
  }
  const getDashboardIcon = ({ name, active }: IGetIcon) => (
    <div
      style={{
        width: '52px',
        height: '41px',
        marginRight: '12px',
        display: 'grid',
        placeItems: 'center',
        borderRadius: '0 40px 40px 0',
        backgroundColor: active ? '#3ea9ff' : 'unset'
      }}
    >
      <i
        className={`icon-${name}`}
        style={{
          fontSize: '22px'
        }}
      />
    </div>
  );
  return (
    <Sidebar
      // width={menuExpanded ? 560 : 372}
      width={width}
      style={{ position: 'relative', backgroundColor: 'var(--fc-blue)' }}
      collapsible
      className="frame-sidebar"
    >
      {/* {draggableHandler} */}
      <div style={{ height: '100%' }}>
        <Sidenav
          appearance="inverse"
          style={{ height: '100%' }}
          defaultOpenKeys={['2']}
        >
          <div className="nav-title"></div>
          <Sidenav.Body>
            <Nav activeKey="1">
              {hasGroup && (
                <Nav.Item
                  eventKey="1"
                  active={pathname.includes('group')}
                  icon={getDashboardIcon({
                    name: 'fortinetone-manageUserGroupIcon',
                    active: pathname.includes('group')
                  })}
                  onClick={() => {
                    navigate('/group/accounts', {
                      state: {
                        debug_key: debugKey
                      }
                    });
                  }}
                >
                  <div>Group</div>
                </Nav.Item>
              )}
              <Nav.Item
                eventKey="2"
                active={pathname.includes('organization')}
                icon={getDashboardIcon({
                  name: 'fortinetone-manageUserIcon',
                  active: pathname.includes('organization')
                })}
                onClick={() => {
                  navigate(`/cred/ou`, {
                    state: {
                      debug_key: debugKey
                    }
                  });
                }}
              >
                <div>Account</div>
              </Nav.Item>
            </Nav>
          </Sidenav.Body>
        </Sidenav>
      </div>
    </Sidebar>
  );
};
